import wixWindow from 'wix-window';
import { memory, session, local } from 'wix-storage';
import { currentUser, applySessionToken, logout } from 'wix-users';
import { getVdgsaSession, killVdgsaSession, VDGSA_USER } from 'public/vdgsa.js';
import { createWixSession } from 'backend/vdgsa-auth.jsw';
import { to, url, path } from 'wix-location';

$w.onReady(async function () {
    getVdgsaSession().then((vdgsaUser) => {
        console.log('vdgsaUser.username', vdgsaUser.username)
        console.log('vdgsaUser.subscription', vdgsaUser.subscription)
        if (vdgsaUser.username && vdgsaUser.subscription) {
            createWixSession(vdgsaUser.username)
                .then((sessionToken) => {
                    applySessionToken(sessionToken.sessionToken)
                        .then(() => {
                            console.log("User logged in.");
                            setLoginButtons()
                        });
                    session.setItem(VDGSA_USER, JSON.stringify(vdgsaUser))
                }), (error) => {
                    console.log("error", error);
                };
        } else {
            session.setItem(VDGSA_USER, JSON.stringify(vdgsaUser))
            if (wixWindow.viewMode === 'Site') {
                logout()
            }
            setLoginButtons()
        }
    })
});

export function setLoginButtons() {
    console.log('currentUser', currentUser)
    console.log('setLoginButtons vdgsaUser', session.getItem('vdgsaUser'))
    let vdgsaUser = session.getItem('vdgsaUser') ? session.getItem('vdgsaUser') : "{}"
    if (currentUser.role ==='Member') {
            console.log('Logged in with Subscription')
            $w('#membershipButton').show()
            $w('#loginButtonBaner').hide()
            $w('#logoutButton').hide()
    } else {
        $w('#logoutButton').hide()
        if (JSON.parse(vdgsaUser).username) {
            console.log(' logged in no Subscription')
            $w('#membershipButton').show()
            $w('#loginButtonBaner').hide()
        } else {
            console.log('Visitor')
            $w('#membershipButton').hide()
            $w('#loginButtonBaner').show()
        }
    }

}
export function goToRenewButton_click(event) {
    console.log('goToRenewButton_click', url)
    let currentPage = url;
    to(`https://hume.vdgsa.org/accounts/?next=${url}`)
}

export function goToLoginButton_click(event) {
    console.log('goToLoginButton_click', url)
    let currentPage = url;
    to(`https://hume.vdgsa.org/login/?next=${url}`)
}

export function logout_click(event) {
    console.log('logout_click')
    killVdgsaSession().then((ret) => {
        console.log('killVdgsaSession-return', ret)
        to('https://hume.vdgsa.org/logout/')
    })
}